<template>
  <Header_en_m></Header_en_m>
  <Team_index_en_m></Team_index_en_m>
  <Team_index_bar_en_m></Team_index_bar_en_m>
  <router-view/>
  <Footer_en_m></Footer_en_m>
</template>

<script>
import Header_en_m from "@/components/EN_mobile/Header_en_m";
import Team_index_en from "@/components/EN/team/Team_index_en";
import Team_index_bar_en_m from "@/components/EN_mobile/team/Team_index_bar_en_m";
import Footer_en_m from "@/components/EN_mobile/Footer_en_m";
import Team_index_en_m from "@/components/EN_mobile/team/Team_index_en_m";

export default {
  name: 'Team_en_m',
  components: {
    Team_index_en_m,
    Footer_en_m,
    Team_index_bar_en_m, Team_index_en, Header_en_m, },

}

</script>
